// extracted by mini-css-extract-plugin
export default {"buttons":"activitiesListColumns_buttons__DDT2h","link":"activitiesListColumns_link__J6s-c","simpleText":"activitiesListColumns_simpleText__taKTM"};